// extracted by mini-css-extract-plugin
module.exports = {"gwMediaText":"TextDirective-hashed__gwMediaText__1CAfL","gwMediaTextSection":"TextDirective-hashed__gwMediaTextSection__2dC-z"};